import { render } from "./filterFooters.vue?vue&type=template&id=2aaaf95b"
import script from "./filterFooters.vue?vue&type=script&lang=js"
export * from "./filterFooters.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./filterFooters.vue?vue&type=style&index=0&id=2aaaf95b&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__